module.exports = __webpack_public_path__ + "img/energy-white.c4801c25.png";